import { render, staticRenderFns } from "./LeftGradientBlockLayout.vue?vue&type=template&id=68502574&"
import script from "./LeftGradientBlockLayout.vue?vue&type=script&lang=js&"
export * from "./LeftGradientBlockLayout.vue?vue&type=script&lang=js&"
import style0 from "./LeftGradientBlockLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports